import { network } from 'services/network';

import { QueryParams, QueryResponse } from 'api/queries/getScheduleQualityTrend.query';

export const ENDPOINT = 'api/bo/getScheduleQualityTrend';

export const getScheduleQualityTrend = (params: QueryParams): Promise<QueryResponse> => {
    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
